import { Locale, SubtitleTextSizes } from '../typings';

export const en_US: Locale = {
  name: 'en_US',
  translations: {
    General: {
      On: 'On',
      Off: 'Off',
    },
    BottomControls: {
      NowPlaying: 'Now Playing',
      PlayingOn: (device: string) => `Playing on ${device}`,
    },
    ContextMenuOverlay: {
      Version: (version: string) => `Version: ${version}`,
      PoweredByBeachbody: 'Powered by Beachbody',
    },
    ErrorOverlay: {
      ErrorCode: (code: number) => `Error ${code}`,
      CannotBePlayed: 'This video cannot be played.',
      PleaseTryAgain: 'Please try again later.',
    },
    LanguageOptions: {
      Subtitles: 'Subtitles',
      SubtitleOptions: 'Subtitle Options',
      Audio: 'Audio',
    },
    SubtitleOptions: {
      FontSize: 'Font Size',
      TextSizeOption: textSize => {
        switch (textSize) {
          case SubtitleTextSizes.Smallest:
            return 'Smallest';
          case SubtitleTextSizes.Small:
            return 'Small';
          case SubtitleTextSizes.Normal:
            return 'Normal';
          case SubtitleTextSizes.Large:
            return 'Large';
          case SubtitleTextSizes.Largest:
            return 'Largest';
          default:
            return 'Normal';
        }
      },
      FontColor: 'Font Color',
      BoldText: 'Bold Text',
    },
    ModifierIndicator: {
      Modifier: 'Modifier',
    },
    ResumeOverlay: {
      AboutToPlay: 'About To Play',
      ResumeVideo: 'Resume Video',
      StartOver: 'Start Over',
    },
  },
};
